import {memo} from 'react';

import {noop, orderBy} from 'lodash';

import {DropdownList} from './dropdown.styled';
import ReorderItem from './Dropdown/components/ReorderItem';

const ReorderList = ({
  items,
  handleSetListRef,
  handleListScroll,
  handleOnPreviewClick,
  handleOnReorderClick,
  isPage,
}) => {
  const sortedItems = orderBy(items, 'orderId', 'desc');
  const data = sortedItems.length > 9 ? sortedItems.slice(0, 9) : sortedItems;

  return (
    <DropdownList ref={isPage ? noop : handleSetListRef} isPage={isPage} onScroll={handleListScroll}>
      {data.map(
        ({orderId, deliveryMethod, restaurantId, restaurantName, restaurantUrl, restaurantLogoUrl, price, date}) => (
          <ReorderItem
            key={orderId}
            orderId={orderId}
            isPage={isPage}
            restaurant={{
              id: restaurantId,
              name: restaurantName,
              url: restaurantUrl,
              logoUrl: restaurantLogoUrl,
            }}
            deliveryMethod={deliveryMethod}
            date={date}
            price={price}
            handleOnPreviewClick={handleOnPreviewClick}
            handleOnReorderClick={handleOnReorderClick}
          />
        ),
      )}
    </DropdownList>
  );
};

export default memo(ReorderList);
